import withIcon from './NewIcon';
// @ts-ignore
import IconRankS from './icon/s/rank.s.svg';

export default withIcon(IconRankS);
